<template>
	<div>
		<div
			v-if="title"
			class="d-flex"
		>
			<ao-icon
				class="mr-3"
				size="large"
				:iconName="iconName"
			/>
			<div class="ao-h2 text-textBody">{{ title }}</div>
		</div>
		<div class="d-flex flex-wrap">
			<div
				v-for="item in params"
				:key="item.name"
				class="mr-3 mb-1 d-flex"
				:class="`${item.classes}`"
			>
				<ao-icon
					class="mr-1"
					:iconName="item.icon"
				/>
				<span class="ao-p4-medium text-textBody text-no-wrap">{{ item.name }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PreviewSubtitle',

	props: {
		params: {
			type: Array,
		},
		title: {
			type: String,
		},
		iconName: {
			type: String,
		},
	},
}
</script>
